import {UPDATE_SPINNER_LOADING} from '../actions/spinner.actions';
import {SpinnerReducerType} from '../actions/types/spinner.action.types';

export interface SpinnerReducerState {
    isLoading: boolean;
}

export const preloadedState = {
    isLoading: true,
};

export const spinnerReducer = (state = preloadedState, action: SpinnerReducerType): SpinnerReducerState => {
    switch (action.type) {
        case UPDATE_SPINNER_LOADING:
            return {...state, isLoading: action.payload};
        default:
            return state;
    }
};
